var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurplePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "purple_plus.svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #7b7cd5;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-width: 3px;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_543_copy_2",
    "data-name": "Ellipse 543 copy 2",
    className: "cls-1",
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape_545_copy_3",
    "data-name": "Shape 545 copy 3",
    className: "cls-2",
    d: "M4150,1190h17",
    transform: "translate(-4143 -1174)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_545_copy_6",
    "data-name": "Shape 545 copy 6",
    className: "cls-2",
    d: "M4158.5,1199v-17",
    transform: "translate(-4143 -1174)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePlus);
export default __webpack_public_path__ + "static/media/purple_plus.44f78a59b0ca5d6e673e20d534547fc4.svg";
export { ForwardRef as ReactComponent };